import t from "../common/localization";
import React from "react";
import { useSelector } from "react-redux";
import { useAttributePreference } from "../common/preferences";
import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatPosition,
  formatDurationTime,
} from "../common/formatter";
import FaceIcon from "@material-ui/icons/Face";
import FavoriteIcon from "@material-ui/icons/Favorite";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import Divider from "@material-ui/core/Divider";
import SpeedIcon from "@material-ui/icons/Speed";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BatteryStdIcon from "@material-ui/icons/BatteryStd";
import NavigationIcon from "@material-ui/icons/Navigation";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";
import { Grid, List, ListItem } from "@material-ui/core";
import { isWidthUp, makeStyles, withWidth } from "@material-ui/core";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import LockIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import Avatar from "@material-ui/core/Avatar";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    borderRadius: 15,
    // backgroundColor: "#F1F3F6",
    fontSize: 10,
    width: "200px"
  },
  value1: {
        color: "#007215",
        textAlign: "center",
    },
    value: {
        textAlign: "center",
    },
  chip: {
       margin: theme.spacing(0.5),
    }
}));

const StopView = ({ deviceId, onShowDetails }) => {
  const device = useSelector((state) => state.devices.items[deviceId]);
  const position = onShowDetails.stopPosition;
  const startPosition = onShowDetails.startPosition;

  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const volumeUnit = useAttributePreference("volumeUnit");

  const handleClick = (e) => {
    e.preventDefault();
  };
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
       <Grid container spacing={1} justify="center" alignItems="center">
       <Grid item xs={5} className={classes.value1}>
        <b>{t("stopNumber")}{onShowDetails.stopIndex}</b>
       </Grid>
       <Grid container spacing={1} direction="row" justify="space-evenly" alignItems="center">
       <Grid item xs={8} className={classes.value}>
         <b>{t("stopDuration")} {formatDurationTime(onShowDetails.stopDuration)}</b>
       </Grid>
       </Grid>
       <Grid container spacing={1} direction="row" justify="space-evenly" alignItems="center">
       <Grid item xs={1}>
         { <LocationOnIcon style={{ color: "#0C9F95", fontSize: "18", alignItems: "right" }}/>}
       </Grid>
       <Grid item xs={11}>
         <b>{position.address || "No Data"}</b>
       </Grid>
       </Grid>
       <Grid item xs={12}>
       <Chip
        label= {(<><b>{ t("stopTime")} {formatDate(position.serverTime, "MMM D, hh:mm A")}</b></>)}
        icon={<AccessTimeIcon/>}
         className={classes.chip}
         size="small"
         color="secondary"
         style={{
               backgroundColor: "#FFE9D1",
               color: "#ce5934",
               borderRadius: 3,
               }}
               />
       </Grid>
       <Grid item xs={12}>
       <Chip
        label=<b>{ t("startTime")} {formatDate(startPosition.serverTime, "MMM D, hh:mm A")}</b>
        icon={<AccessTimeIcon/>}
         className={classes.chip}
         size="small"
         color="secondary"
         style={{
               backgroundColor: "#E7F4DE",
               color: "green",
               borderRadius: 3,
               }}
               />
       </Grid>
       </Grid>
       </div>
    </>
  );
};

export default StopView;
